var api = require("!../../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../node_modules/css-loader/dist/cjs.js??ref--2-oneOf-0-0!../../../../../../node_modules/vue-loader/dist/stylePostLoader.js!../../../../../../node_modules/@tarojs/webpack-runner/node_modules/postcss-loader/dist/cjs.js??ref--3-0!../../../../../../node_modules/@dcasia/mini-program-tailwind-webpack-plugin/node_modules/windicss-webpack-plugin/dist/loaders/windicss-template.cjs!../../../../../../node_modules/@dcasia/mini-program-tailwind-webpack-plugin/node_modules/windicss-webpack-plugin/dist/loaders/windicss-template.cjs!../../../../../../node_modules/less-loader/dist/cjs.js??ref--6-0!../../../../../../node_modules/vue-loader/dist/index.js??ref--12-0!./new-payment-method.vue?vue&type=style&index=0&id=3844ee22&lang=less");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};